import { type Enum } from '@webapp/infrastructure/types/Enum'

export const AccountCodeTypes = {
  ASSET: 0,
  LIABILITY: 1,
  EXPENSE: 2,
  INCOME: 3,
  EQUITY: 4,
  OTHER: 5,
} as const

export type AccountCodeTypeEnum = Enum<typeof AccountCodeTypes>

export const AccountCodeTypeLabels: Record<AccountCodeTypeEnum, string> = {
  [AccountCodeTypes.ASSET]: 'Asset',
  [AccountCodeTypes.LIABILITY]: 'Liability',
  [AccountCodeTypes.EXPENSE]: 'Expense',
  [AccountCodeTypes.INCOME]: 'Income',
  [AccountCodeTypes.EQUITY]: 'Equity',
  [AccountCodeTypes.OTHER]: 'Other',
}
